import styled from 'styled-components'
import { Spacings, Text, COLORS } from '@styles'

export const PaymentTermsTableWrapper = styled.div`
	width: 100%;

	& tbody tr:nth-child(even) td {
		background: ${COLORS.gray[50]};
	}
`

export const PaymentTermsEmptyState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	gap: ${Spacings.SPACING_2B};
	padding: ${Spacings.SPACING_8B} ${Spacings.SPACING_4B};
`

export const PaymentTermsEmptyImage = styled.img`
	width: 138px;
	height: 100px;
`

export const PaymentTermsEmptyTitle = styled.p`
	margin: 0;
	font-size: 18px;
	font-weight: ${Text.BOLD_600};
	color: ${({ theme }) => theme.colors.text.primary};
`

export const PaymentTermsEmptyText = styled.p`
	margin: 0;
	max-width: 22rem;
	font-size: ${Text.MEDIUM};
	color: ${({ theme }) => theme.colors.text.secondary};
`
